import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@vendure/admin-ui/core';
import {ImagePickerComponent} from './image-picker.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ClarityModule} from '@clr/angular';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ClarityModule, SharedModule],
  declarations: [ImagePickerComponent],
  exports: [ImagePickerComponent],
})
export class ImagePickerModule {}
